import LogoImg from 'assets/img/logo512.png'
import LogoWhiteImg from 'assets/img/logo-white512.png'

export default ({ whiteLogo }) => (
  <img className="tt-logo" alt="Ticketteer Logo" src={whiteLogo ? LogoWhiteImg : LogoImg} />
)
